import { render, staticRenderFns } from "./MotivosDiscordar.vue?vue&type=template&id=1c7bdea6"
import script from "./MotivosDiscordar.vue?vue&type=script&lang=js"
export * from "./MotivosDiscordar.vue?vue&type=script&lang=js"
import style0 from "./MotivosDiscordar.vue?vue&type=style&index=0&id=1c7bdea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports